const deleteCronTemplate = async ({ params, api }) => {
  const { previousData } = params;
  const { id } = previousData;
  return await api(`cronTemplate/${id}`, { body: { id }, method: 'DELETE' })
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default deleteCronTemplate;
